import { createFileRoute, Outlet } from "@tanstack/solid-router";
import { backendService } from "../../../backend/backend.service";
import { ValidationError } from "../../../backend/models/errors/Validation.error";
import { databaseService } from "../../../services/database.service";
import {
  getDataFromSafeParam,
  getSafeParamNumeric,
} from "../../../utils/get-safe-param-numeric.util";
import { withLoaderErrorHandling } from "../../../utils/with-loader-error-handling";

async function loadCategory(
  templateId: number,
  formId: string,
  categoryId: string
) {
  const numericFormId = getSafeParamNumeric(formId, `/templates/${templateId}`);

  const numericCategoryId = getSafeParamNumeric(
    categoryId,
    `/templates/${templateId}/${formId}`
  );

  const category = await getDataFromSafeParam(
    () => databaseService.getCategory(numericCategoryId),
    `/templates/${templateId}/${formId}`
  );

  const sections =
    await databaseService.getSectionsFromCategory(numericCategoryId);

  const itemCount = await databaseService.getItemCountForSections(
    sections.map((x) => x.id!)
  );

  return { category, sections, itemCount };
}

export const Route = createFileRoute("/history/$formId/$categoryId")({
  loader: async ({ params, parentMatchPromise }) =>
    withLoaderErrorHandling(async () => {
      const categoryId = Number(params.categoryId);

      if (!Number.isInteger(categoryId)) {
        throw new ValidationError(
          "Parameter is not valid",
          "CATEGORY",
          "categoryId",
          params.categoryId
        );
      }

      const category = await backendService.getCategory(categoryId);

      const sections = await backendService.getSections(categoryId);

      const parentMatch = await parentMatchPromise;
      const parentLoaderData = parentMatch.loaderData;

      if (!parentLoaderData) {
        throw new Error("Failed to load parentData");
      }

      return {
        category,
        sections,
        formId: parentLoaderData.formId,
        formName: parentLoaderData.form.templateName,
      };
    }, `/history/${params.formId}`),
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
